var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconhandpicked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.909,
    height: 16,
    viewBox: "0 0 18.909 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(51,51,51,0.78);}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.108,4a2.381,2.381,0,0,0-2.381,2.381c0,2.282,2.635,4.457,3.879,5.435l.04.033.007.006a.727.727,0,0,0,.875,0l.01-.009,0,0,.01-.009c1.236-.97,3.9-3.16,3.9-5.453A2.381,2.381,0,0,0,17.074,4a2.592,2.592,0,0,0-1.983,1.091A2.592,2.592,0,0,0,13.108,4ZM6.364,11.273a2.182,2.182,0,0,0-.812.158L2,12.727v5.818l3.07-1.334A1.464,1.464,0,0,1,6.207,17.2L12.8,19.892h0a1.077,1.077,0,0,0,1.007-.036h0l6.536-3.631h0a1.089,1.089,0,0,0-.993-1.937h0l-4.991,2.078H13.273a1.091,1.091,0,0,0,.338-2.128h0L7.288,11.477H7.28A2.182,2.182,0,0,0,6.364,11.273Z",
    transform: "translate(-2 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconhandpicked);
export default __webpack_public_path__ + "static/media/icon handpicked.a66701921d9fe670b4b6ae8eeaaadb9b.svg";
export { ForwardRef as ReactComponent };